export class Bulletin {
  author: string;
  authorId: string;
  body: string;
  communityId: string;
  id: string;
  timestamp: number;
  title: string;

  constructor(author = "", authorId = "", body = "", communityId = "", id = "", timestamp = 0, title = "") {
    this.author = author;
    this.authorId = authorId;
    this.body = body;
    this.communityId = communityId;
    this.id = id;
    this.timestamp = timestamp;
    this.title = title;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/notice-board/bulletin.ts